var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":_vm.title,"title-link-class":_vm.classTab,"active":_vm.active}},[_c('b-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }